import {all, fork} from "redux-saga/effects";
import {put, takeEvery} from "@redux-saga/core/effects";
import {
    deleteElement,
    deleteElementError,
    deleteElementSuccess,
    getAllElement,
    getAllElementError,
    getAllElementSuccess,
    saveElement, saveElementError,
    saveElementSuccess,
    updateElement,
    updateElementSuccess,
    AdoptionElement,
    updateElementError,
    GetAllElementPayloadAdoption
} from "../reducers/Adoption/AdoptionReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {PayloadAction} from "@reduxjs/toolkit";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";
import { actions } from "react-table";

function* getAllElementSaga(){
    yield takeEvery(getAllElement.type, function* (action: PayloadAction<GetAllElementPayloadAdoption>) {
        let response : CustomFetchResponse = yield CustomFetch({
            method: "POST",
            url: apiPaths.allAdoption,
            authenticated: true,
            data: action.payload.pageableDto
        })

        if (response.status === 200){
            yield put({type: getAllElementSuccess.type, payload: {
                data: response.data.data,
                currentPage: response.data.currentPage,
                numberOfPage: response.data.numberOfPage,
                totalRows: response.data.totalRows,
            }})
        } else {
            yield put({type: getAllElementError.type})
        }
    })
}

function* saveElementSaga() {
    yield takeEvery(saveElement.type, function* (action: PayloadAction<AdoptionElement>) {
        let response: CustomFetchResponse = yield CustomFetch({method: "POST", url: apiPaths.saveAdoption, authenticated: true, data: action.payload})

        if(response.status === 200){
            yield put({type: saveElementSuccess.type, payload: response.data})
        } else {
            yield put({type: saveElementError.type})
        }

        //This is only for mock functionality
        yield put({type: saveElementSuccess.type, payload: action.payload})
        yield put({
            type: openSnackbar.type, payload: {
                open: true,
                message: 'Element added successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            }
        })
    })
}



function* deleteElementSaga() {
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<string>) {



        const url = `${apiPaths.deleteUser}/${action.payload}`
        let response: CustomFetchResponse = yield CustomFetch({method: "DELETE", url: url, authenticated: true, data: action.payload})

        if(response.status === 200){
            yield put({type: deleteElementSuccess.type, payload: response.data.content})
            yield put({type: getAllElement.type})
        } else {
            yield put({type: deleteElementError.type})
        }

        yield put({
            type: openSnackbar.type, payload: {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            }
        })
    })
}

function* updateElementSaga() {
    yield takeEvery(updateElement.type, function* (action: PayloadAction<AdoptionElement>) {
        let response: CustomFetchResponse = yield CustomFetch({method: "PUT", url: apiPaths.updateAdoption, data: action.payload})

        if (response.status === 200){
            yield put ({
                type: updateElementSuccess.type,
                payload: response.data
            })
        }
        else {
            yield put ({
                type: updateElementError.type,
            })
        }
    });

    yield put({
        type: updateElementSuccess.type,
        payload: actions.payload
    })
    yield put({
        type: openSnackbar.type, payload: {
            open: true,
            message: 'Element updated successfully',
            variant: 'alert',
            alert: {
                color: 'success'
            }
        }
    })
}


export default function* AdoptionSaga() {
    yield all(
        [
            fork(getAllElementSaga),
            fork(saveElementSaga),
            fork(updateElementSaga),
            fork(deleteElementSaga)
            
        ],
    )
}